/* eslint-disable react/jsx-props-no-spreading */
import type { VoidFunctionComponent } from 'react';

import { useAddToast } from '../../../../contexts/ToastContext';
import { QualityRequired, SecurityRequired } from '../../../generic/Gates';
import Redirect from '../../../generic/Redirect';
import Header from '../../../shared/settings/SettingsPageHeader';
import PageContent from '../shared/SettingsPageContent';

import Licensing from './Licensing';
import ProjectSBOMPoliciesSettings from './ProjectSBOMPoliciesSettings';
import Quality from './Quality';
import Security from './Security';
import useProjectIssuesSettings from './useProjectIssuesSettings';
import useSBOMProjectSettings from './useSBOMProjectSettings';

/**
 * ProjectPoliciesSettingsContainer
 */
const ProjectPoliciesSettingsContainer: VoidFunctionComponent = () => {
  const {
    isLoading,
    isSaving,
    isSaveButtonDisabled,
    shouldShowIssues,
    projectSettingsBaseURL,
    onSave,
    licensing,
    security,
    quality,
  } = useProjectIssuesSettings();
  const addToast = useAddToast();
  const sbomSettings = useSBOMProjectSettings();

  if (!shouldShowIssues && !sbomSettings.canEditPolicy) {
    return (
      <Redirect to={projectSettingsBaseURL} />
    );
  }

  return (
    <PageContent isLoading={isLoading}>
      <Header heading="Issue Policies">
        <Header.Paragraph>
          Configure how Licensing, Security, Quality and SBOM are handled within this project.
        </Header.Paragraph>
        <Header.SaveButton
          isLoading={isSaving}
          isDisabled={isSaveButtonDisabled}
          onClick={() => {
            addToast({ type: 'info', content: 'Saving project settings and running issue scan...' });
            onSave();
          }}
        />
      </Header>
      <Licensing
        {...licensing}
      />
      <SecurityRequired>
        <Security
          {...security}
        />
      </SecurityRequired>
      <QualityRequired>
        <Quality
          {...quality}
        />
      </QualityRequired>
      <ProjectSBOMPoliciesSettings {...sbomSettings} />
    </PageContent>
  );
};

export default ProjectPoliciesSettingsContainer;
